/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BsShopIntegrationInput
 */
export interface BsShopIntegrationInput {
    /**
     * 
     * @type {string}
     * @memberof BsShopIntegrationInput
     */
    hostname?: string;
    /**
     * 
     * @type {string}
     * @memberof BsShopIntegrationInput
     */
    port?: string;
    /**
     * 
     * @type {string}
     * @memberof BsShopIntegrationInput
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof BsShopIntegrationInput
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof BsShopIntegrationInput
     */
    databaseName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BsShopIntegrationInput
     */
    b2cCentres?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BsShopIntegrationInput
     */
    b2bCentres?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BsShopIntegrationInput
     */
    skippedEmailAddressList?: string;
}

/**
 * Check if a given object implements the BsShopIntegrationInput interface.
 */
export function instanceOfBsShopIntegrationInput(value: object): value is BsShopIntegrationInput {
    return true;
}

export function BsShopIntegrationInputFromJSON(json: any): BsShopIntegrationInput {
    return BsShopIntegrationInputFromJSONTyped(json, false);
}

export function BsShopIntegrationInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): BsShopIntegrationInput {
    if (json == null) {
        return json;
    }
    return {
        
        'hostname': json['hostname'] == null ? undefined : json['hostname'],
        'port': json['port'] == null ? undefined : json['port'],
        'username': json['username'] == null ? undefined : json['username'],
        'password': json['password'] == null ? undefined : json['password'],
        'databaseName': json['databaseName'] == null ? undefined : json['databaseName'],
        'b2cCentres': json['b2cCentres'] == null ? undefined : json['b2cCentres'],
        'b2bCentres': json['b2bCentres'] == null ? undefined : json['b2bCentres'],
        'skippedEmailAddressList': json['skippedEmailAddressList'] == null ? undefined : json['skippedEmailAddressList'],
    };
}

export function BsShopIntegrationInputToJSON(json: any): BsShopIntegrationInput {
    return BsShopIntegrationInputToJSONTyped(json, false);
}

export function BsShopIntegrationInputToJSONTyped(value?: BsShopIntegrationInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hostname': value['hostname'],
        'port': value['port'],
        'username': value['username'],
        'password': value['password'],
        'databaseName': value['databaseName'],
        'b2cCentres': value['b2cCentres'],
        'b2bCentres': value['b2bCentres'],
        'skippedEmailAddressList': value['skippedEmailAddressList'],
    };
}

